import { ref } from "vue";
import {
  sendQuoteWhatsAppViaBackend,
  type BuildNotifyQuoteParams,
  type SendQuoteNotifyResponse,
} from "@/services/emailBackendService";

export type BuildNotifyWhatsAppParams = Omit<BuildNotifyQuoteParams, "canales"> & {
  telefono: string;
  /** @deprecated usar `nombre` */
  customerName?: string;
};

export const useWhatsApp = () => {
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const sendQuoteWhatsApp = async (
    params: BuildNotifyWhatsAppParams,
  ): Promise<SendQuoteNotifyResponse> => {
    isLoading.value = true;
    error.value = null;

    try {
      const result = await sendQuoteWhatsAppViaBackend({
        idCotizacion: params.idCotizacion,
        telefono: params.telefono,
        email: params.email,
        nombre: params.nombre ?? params.customerName,
        prima: params.prima,
        fechaVigencia: params.fechaVigencia,
        quoteData: params.quoteData,
        token: params.token,
      });

      if (!result.success) {
        error.value = result.error || "Error al enviar por WhatsApp";
      }

      return result;
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "Error desconocido al enviar WhatsApp";
      error.value = errorMessage;

      return {
        success: false,
        error: errorMessage,
      };
    } finally {
      isLoading.value = false;
    }
  };

  const clearError = () => {
    error.value = null;
  };

  return {
    isLoading,
    error,
    sendQuoteWhatsApp,
    clearError,
  };
};
